export const RISK_TYPES_ASTOR = [
  { value: "income", label: "Income" },
  { value: "conservative", label: "Conservative" },
  { value: "moderate", label: "Moderate" },
  { value: "aggressive", label: "Aggressive" },
  { value: "equity", label: "Equity" },
];
